var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema, type, defaultValue } from "./decorators/type.js";
import { registerSchema } from "./components/ComponentRegistry.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let MaskSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "pixiComponent");
    __publicField(this, "maskKey");
    __publicField(this, "anchorX");
    __publicField(this, "anchorY");
    __publicField(this, "width");
    __publicField(this, "height");
  }
};
__decorateClass([
  type("string"),
  defaultValue("Sprite")
], MaskSchema.prototype, "pixiComponent", 2);
__decorateClass([
  type("string")
], MaskSchema.prototype, "maskKey", 2);
__decorateClass([
  type("number"),
  defaultValue(0.5)
], MaskSchema.prototype, "anchorX", 2);
__decorateClass([
  type("number"),
  defaultValue(0.5)
], MaskSchema.prototype, "anchorY", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], MaskSchema.prototype, "width", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], MaskSchema.prototype, "height", 2);
MaskSchema = __decorateClass([
  Component("Mask")
], MaskSchema);
registerSchema(MaskSchema);
const __vite_glob_0_28 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get MaskSchema() {
    return MaskSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  MaskSchema as M,
  __vite_glob_0_28 as _
};
//# sourceMappingURL=Mask-de6e3148.js.map
